import { AnswerTypes } from "../actions/answer";
import { UserTypes } from "../actions/user";

const initialState = {
  loading: false,
  collection: []
};

const answer = (state = initialState, { type, payload }) => {
  switch (type) {
    case AnswerTypes.SET_ANSWER:
      const answers = [...state.collection];
      answers[payload.id - 1] = payload.answer;

      return { ...state, collection: answers };

    case AnswerTypes.CREATE_START:
    case AnswerTypes.CREATE_FAILURE:
      return { ...state, loading: false };

    case AnswerTypes.CREATE_SUCCESS:
      return state;

    case UserTypes.SWITCH_PROGRAM_SUCCESS:
      return initialState;
    default:
      return state;
  }
};

export default answer;



// WEBPACK FOOTER //
// ./src/reducers/answer.js